import { reportingModuleManifest } from '../reporting.module.js';
import { reportingSettingRegistrations } from '../settings/reporting-setting-definitions.js';
export const reportingWebModuleContribution = {
    moduleId: 'reporting', manifest: reportingModuleManifest,
    settingRegistrations: reportingSettingRegistrations,
    settingEditors: [], hostContracts: [], hostContributions: [],
    routes: [{
            id: 'reporting.web.definitions', moduleId: 'reporting', path: '/reporting',
            requiredPermission: 'reporting.definitions.read',
            navigation: {
                id: 'reporting.navigation.definitions', fallbackLabel: 'Reporting',
                labelConfigurationKey: 'reporting.copy.definitions',
                labelValueProperty: 'navigationLabel', priority: 85,
            },
            load: () => import('./reporting-definitions.page.js'),
        }],
};
export default reportingWebModuleContribution;
//# sourceMappingURL=reporting-web.module-contribution.js.map